import React from 'react';
import { motion } from 'framer-motion';
import { Sprout, DollarSign, Target, Sparkles, ArrowRight, Leaf } from 'lucide-react';
export function Closing() {
  return <section className="relative w-full py-12 md:py-20 px-4 bg-gradient-to-b from-green-800 to-green-950 text-white overflow-hidden" data-id="element-50">
      {/* Decorative Background Leaves */}
      <motion.div animate={{
      y: [0, -20, 0],
      rotate: [0, 10, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-10 left-10 opacity-10 pointer-events-none" data-id="element-51">
        <Leaf className="w-24 h-24 text-lime-400" data-id="element-52" />
      </motion.div>
      <motion.div animate={{
      y: [0, 20, 0],
      rotate: [0, -10, 0]
    }} transition={{
      duration: 7,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute bottom-10 right-10 opacity-10 pointer-events-none" data-id="element-53">
        <Sprout className="w-32 h-32 text-lime-400" data-id="element-54" />
      </motion.div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-56">
          <div className="flex items-center justify-center gap-2 mb-4 md:mb-6" data-id="element-57">
            <Sprout className="w-8 h-8 md:w-10 md:h-10 text-lime-400" data-id="element-58" />
            <h2 className="text-2xl md:text-4xl font-bold" data-id="element-59">🌱 CIERRE</h2>
          </div>

          <p className="text-xl md:text-3xl font-bold mb-6 md:mb-8 text-green-50" data-id="element-60">
            Esto no es solo una huerta.
          </p>

          <div className="space-y-3 md:space-y-4 mb-8 md:mb-12 inline-block text-left" data-id="element-61">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="flex items-center gap-3 text-lg md:text-xl font-medium bg-white/10 px-6 py-3 rounded-xl backdrop-blur-sm" data-id="element-62">
              <DollarSign className="w-5 h-5 md:w-6 md:h-6 text-lime-400" data-id="element-63" />
              <span data-id="element-64">gastar menos</span>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex items-center gap-3 text-lg md:text-xl font-medium bg-white/10 px-6 py-3 rounded-xl backdrop-blur-sm" data-id="element-65">
              <Target className="w-5 h-5 md:w-6 md:h-6 text-lime-400" data-id="element-66" />
              <span data-id="element-67">tener control</span>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="flex items-center gap-3 text-lg md:text-xl font-medium bg-white/10 px-6 py-3 rounded-xl backdrop-blur-sm" data-id="element-68">
              <Sparkles className="w-5 h-5 md:w-6 md:h-6 text-lime-400" data-id="element-69" />
              <span data-id="element-70">hacer algo propio</span>
            </motion.div>
          </div>

          <div className="flex justify-center" data-id="element-71">
            <motion.a href="#pricing" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="relative inline-flex items-center justify-center gap-2 bg-lime-500 hover:bg-lime-400 text-green-950 font-black text-lg md:text-xl px-8 py-4 md:px-10 md:py-5 rounded-xl shadow-[0_0_20px_rgba(132,204,22,0.3)] transition-all w-full md:w-auto" data-id="element-72">
              👉 Empezá hoy con Huerta Express 30D
              <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-73" />
              <Leaf className="absolute -bottom-3 -left-2 w-5 h-5 text-lime-400 -rotate-12 drop-shadow-sm" data-id="element-74" />
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}